import dayjs from "dayjs";
import encode from "jwt-encode";
import { jwtDecode as decode } from "jwt-decode";
import md5 from "js-md5";

const RAW_SECRET = process.env.REACT_APP_API_JWT_KEY;
const SECRET = md5(RAW_SECRET); // 與後端 PayloadHelper 一致：先 MD5 再當 HMAC key
const SECOND = process.env.REACT_APP_API_JWT_EXPIRED_SECONDS;

/* API 傳輸用的 JWT 解密 */
export const jwtDecode = (token) => {
  return decode(token, SECRET);
};

/** API 傳輸用的 JWT 加密 */
export const jwtEncode = (payload) => {
  const exp = dayjs().add(SECOND, "second").unix();
  return encode({ ...payload, Exp: exp }, SECRET);
};
